import mainApi from "./mainApi";
import { useQuery } from "react-query";
import { getAge, getCountry, translateANT } from "../helpers/toolsHelper";
import countriesNames from "i18n-iso-countries";
import { debugBenefits } from "helpers/DebugBenefits";
import { useBenefitByCode, useCoverageQuery } from "hooks/CoverageQueryHook";
import { transformData, transformOptions } from "components/utils/DataSelectOption.util";
import { useContext } from "react";
import { TextsContext } from "context/textsContext";

export const useCountries = () => {

    countriesNames.registerLocale(require("i18n-iso-countries/langs/en.json"));
    countriesNames.registerLocale(require("i18n-iso-countries/langs/es.json"));
    countriesNames.registerLocale(require("i18n-iso-countries/langs/pt.json"));

    const countrySort = (currentLanguage) => {
        return (a, b) => {
            let aval = (countriesNames.getName(a?.isoNum, currentLanguage) ?? a?.description)?.toLowerCase();
            if (a?.isoNum === "530") aval = translateANT(currentLanguage)
            let bval = countriesNames.getName(b?.isoNum, currentLanguage) ?? b?.description
            if (b?.isoNum === "530") bval = translateANT(currentLanguage)
            return aval.localeCompare(bval)
        }
    }

    return {
        getCountryName: countriesNames.getName,
        countrySort
    }
}

export const useBenefits = () => {

    const { getCurrentLanguage } = useContext(TextsContext);
    const coverageQuery = useCoverageQuery(getCurrentLanguage());

    const config = {
        keepPreviousData: false,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        retry: 3
    }

    const structural = useQuery({
        queryKey: ['structural'],
        queryFn: async ({ signal }) => {

            const structuralBenefit = transformData(coverageQuery?.data, 'structural')
            /* const postData = {
                planId: "152",
                optionId: "2607"
            };

            const { data } = await mainApi.post("/services/quoter-structural-benefits", postData, { signal });
            console.log(data)
            return data; */
            return structuralBenefit

        },
        enabled: !coverageQuery.isLoading && !!coverageQuery.data,
        ...config
    });

    const regular = useQuery({
        queryKey: ['regular'],
        queryFn: async ({ signal }) => {

            const regularBenefit = transformData(coverageQuery?.data, 'regular')

            /* const postData = {
                planId: "152",
                optionId: "2607"
            };
            const { data } = await mainApi.post("/services/quoter-regular-benefits", postData, { signal });
            return data; */
            return regularBenefit

        },
        enabled: !coverageQuery.isLoading && !!coverageQuery.data,
        ...config
    });


    return {
        regular,
        structural,
        debug: debugBenefits,
        regularData: regular?.data?.data ?? [],
        structuralData: structural?.data?.data ?? []
    };
}

export const useQuoter = (context) => {

    const { getCurrentLanguage } = useContext(TextsContext);
    const riderQuery = useBenefitByCode('orgtrans', getCurrentLanguage());

    const config = {
        keepPreviousData: false,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        retry: 3
    }

    const organRiderQuery = useQuery({
        queryKey: ['rider'],
        queryFn: async ({ signal }) => {

            const organBenefit = transformOptions(riderQuery?.data)
            /* const postData = {
                "effectiveDate": "2023-11-11",
                "terminationDate": "2023-11-11"
            };

            const { data } = await mainApi.post("/services/quoter-options-organ-rider", postData, { signal });
            return data; */

            return organBenefit
        },
        ...config,
        enabled: !riderQuery.isLoading && !!riderQuery.data,
    });

    return {
        organRiderQuery,
    };

}

